import { Injectable } from '@angular/core';
import { IIDolOloRequestOFStore } from './iidOlOloRequestOF.store';
import { IID_OL_OLOREQUEST_OF } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolOloRequestOFQuery } from './iidOlOloRequestOF.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.OLO_REQUEST_OF)
export class IIDolOloRequestOFService extends CrudService<IID_OL_OLOREQUEST_OF, IIDolOloRequestOFStore, IIDolOloRequestOFQuery> {
  constructor(
    protected store: IIDolOloRequestOFStore,
    public query: IIDolOloRequestOFQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_OL_OLO_REQUEST_OF,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
